import axios from '../../plugins/axios'

export const listEmail = ({ commit }, { params }={}) => {
  return axios.get('/api/email', { params })
  .then(response => {
    commit('SET_EMAILS', response.data.rows)
    return response
  })
    .catch(err => err.response)
}